<template>
  <div id="hrms15e-detail1Desc1">
    <div class="detail detail-responsive">
      <div class="detail-header" ><h4><u>{{ labels['HRAP31EC32']['90'] }}</u></h4></div>
      <hrms-table :columns="detail1Desc1Table"
                  :data="detail"
                  :addInlineEventBool="validateStaappr"
                  :editInlineEventBool="true"
                  :deleteInlineEventBool="true"
                  :deleteInlineBtnDisp="false"
                  :saveInlineEvent="callSave"
                  :saveInlineBtnDisp="validateStaappr"
                  :columnEvent="columnEvent"  />

    </div>
  </div>

</template>

<script>
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import popup from 'components/hrms15e/popupCourseGap'

export default {
  name: 'hrms15e-detail1Desc1',
  props: [
    'labels',
    'nowLang',
    'searchIndex',
    'indexSelected',
    'detail',
    'detail1Desc1Table',
    'receivedHrms15eDetailCourseAddInline',
    'postDetailCourseSave',
    'validateStaappr'
  ],
  methods: {
    columnEvent (eventName, param) {
      if (param.codcours !== '') {
        let valid = true
        for (var i = 0; i < this.detail.rows.length - 1; i++) {
          if (this.detail.rows[i].codcours === param.codcours) {
            valid = false
          }
        }
        if (valid) {
          this.receivedHrms15eDetailCourseAddInline(param)
        } else {
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgAlreadySelected')
          })
        }
      }
    },
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          let param = {
            codempid_query: this.indexSelected.codempid,
            dteyreap: this.searchIndex.year,
            numtime: this.searchIndex.numtime,
            numseq: this.indexSelected.numseq
          }
          let courseParams = {
            p_dteyreap: this.searchIndex.year,
            p_numtime: this.searchIndex.numtime,
            p_numseq: this.indexSelected.numseq,
            p_codempid_query: this.indexSelected.codempid
          }
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
          }
          this.postDetailCourseSave({ dataRowsHasFlg: dataRowsHasFlg, searchIndex: this.searchIndex, courseParams: courseParams })
        }
      })
    }
  },
  components: {
    popup
  }
}
</script>



// WEBPACK FOOTER //
// detail1Desc1.vue?225665b1